import logoNoBg from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';
import youtube from '../Assets/Imgs/youtube.png';
import insta from '../Assets/Imgs/insta.jpg';
import tiktok from '../Assets/Imgs/tiktok2.png';

const Footer = () => {
  return (
    <div className="footer">
      <img src={logoNoBg} className="logoIcon" />
      <a
        className=""
        href="https://www.youtube.com/channel/UCvySiTZTEIsPKUuBhXsbtZQ"
        //target="_blank"
      >
        <img src={youtube} alt="youtube" className="icon" />
      </a>
      <a
        className=""
        href="https://www.instagram.com/noise_star_band/"
        //target="_blank""
      >
        <img src={insta} alt="insta" className="icon" />
      </a>
      <a
        className=""
        href="https://www.tiktok.com/@noise_star"
        //target="_blank"
      >
        <img src={tiktok} alt="tiktok" className="icon" />
      </a>
    </div>
  );
}

export default Footer;